$(document).ready(function () {

  // --- Cierre del announcement bar ---
  const closeBtns = $(".announcement-bar__close-button");
  closeBtns.each((i, btn) => {
    $(btn).on("click", () => {
      $(btn).closest(".section-announcement").hide();
      document.body.classList.add("announcement-hide");
    });
  });

  // --- Ticker: rotación de mensajes ---
  $(".section-announcement-bar").each(function () {
    const bar = $(this);
    const messages = bar.find(".announcement-bar__message");

    if (messages.length <= 1) return;

    // Leer velocidad desde CSS variable o atributo data (fallback 4s)
    const speedAttr = bar.find(".announcement-bar").data("speed");
    const speed = speedAttr ? parseInt(speedAttr) * 1000 : 4000;

    let current = 0;

    const goTo = (index) => {
      messages.eq(current).removeClass("is-active").addClass("is-leaving");
      setTimeout(() => {
        messages.eq(current).removeClass("is-leaving");
      }, 500);
      current = index;
      messages.eq(current).addClass("is-active");
    };

    const interval = setInterval(() => {
      const next = (current + 1) % messages.length;
      goTo(next);
    }, speed);

    // Pausar en hover
    bar.on("mouseenter", () => clearInterval(interval));
  });

});
